import {Component} from '@angular/core';
import {InfoModalComponent} from "../../views/modal/info_modal.component";
import {ModalService} from "../../views/modal/base_modal.component";
import {TranslateService} from "../../translate/translate.service";
import {FilterFormService} from "../../views/filter_form/filter_form.service";
import {HelperService} from "../../lib/helper.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ChartParams} from "../../views/chart/chart.component";

@Component({
	template: `
		<info-modal [title]="title" (onOk)="ok()">
			<div class="row">
				<div class="col-md-12">
					<chart [data]="chart.data" [options]="chart.options"></chart>
				</div>
			</div>
		</info-modal>
	`
})
export class SiteTopDetailsModalComponent extends InfoModalComponent {
	chart = new ChartParams();

	constructor(
		public activeModal: NgbActiveModal,
		public helper: HelperService,
		public translate: TranslateService,
		public modalService: ModalService,
		public filter: FilterFormService,
	) {
		super(activeModal);
	}

	ok() {
		this.close();
	}
}
